import { useEffect, useState } from 'react';
import { useSound } from '@hooks/useSound';
import { NotificationItem } from '@hooks/useNotifications';

export const useNotificationSound = (
  filteredNotifications: NotificationItem[],
) => {
  const [previousNotificationCount, setPreviousNotificationCount] =
    useState<number>(0);
  const { playNotification } = useSound();

  useEffect(() => {
    if (filteredNotifications.length > 0) {
      if (
        filteredNotifications.length > previousNotificationCount &&
        previousNotificationCount >= 0
      ) {
        playNotification();
      }
      setPreviousNotificationCount(filteredNotifications.length);
    } else if (filteredNotifications.length === 0) {
      setPreviousNotificationCount(0);
    }
  }, [
    filteredNotifications.length,
    previousNotificationCount,
    playNotification,
  ]);

  return { previousNotificationCount };
};
